// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"common_formTitle__13f4y","center":"common_center__2zyNo"};